import React from 'react';
import Navigation from "./components/Navigation";
import LoginForm from "./components/LoginForm";
import './App.css';

class App extends React.Component {
    render() {
        return (
            <div>
                <Navigation/>
                <LoginForm/>
            </div>
        );
    }
}
export default App;